// Generated by purs version 0.14.5
"use strict";
module.exports = {};
